import React, { useState } from 'react';

export default function KaitouAndHensachi({ schedules }) {
  const [showRankGuide, setShowRankGuide] = useState(false);

  // データがない場合は何も表示しない
  if (!schedules || schedules.length === 0) return null;

  const now = new Date();

  // ★ 全日程の中から、公開日時を過ぎている一番新しい回を探す ★
  // (後ろから順に検索して、最初に見つかった公開済みの回を表示します)
  const targetSchedule = [...schedules].reverse().find(item => {
    const ansStr = item.answer_release_date?.replace(/-/g, '/');
    const rankStr = item.rank_release_date?.replace(/-/g, '/');

    const ansDate = ansStr ? new Date(ansStr) : null;
    const rankDate = rankStr ? new Date(rankStr) : null;

    // 解答か偏差値、どちらかの公開日時を過ぎていればその回を対象とする
    return (ansDate && now >= ansDate) || (rankDate && now >= rankDate);
  });

  // 条件に合う回が見つからなければ（すべてNULL、または未来の日時なら）何も表示しない
  if (!targetSchedule) return null;

  // 日付の再パース（表示判定用）
  const ansReleaseDate = targetSchedule.answer_release_date ? new Date(targetSchedule.answer_release_date.replace(/-/g, '/')) : null;
  const rankReleaseDate = targetSchedule.rank_release_date ? new Date(targetSchedule.rank_release_date.replace(/-/g, '/')) : null;

  const isAnswerVisible = ansReleaseDate && now >= ansReleaseDate;
  const isRankVisible = rankReleaseDate && now >= rankReleaseDate;

// KaitouAndHensachi.jsx のリンク生成部分の修正

  // DBのデータからリンク配列を生成（XserverのURLに変更）
  const baseUrl = "https://tosajuku.info/tsjk_webpage/reservation/img/pdf";

  const subjectPdfLinks = [
    { label: "英語", url: targetSchedule.pdf_eng ? `${baseUrl}/${targetSchedule.pdf_eng}` : null },
    { label: "数学", url: targetSchedule.pdf_math ? `${baseUrl}/${targetSchedule.pdf_math}` : null },
    { label: "国語", url: targetSchedule.pdf_lang ? `${baseUrl}/${targetSchedule.pdf_lang}` : null },
    { label: "理科", url: targetSchedule.pdf_sci ? `${baseUrl}/${targetSchedule.pdf_sci}` : null },
    { label: "社会", url: targetSchedule.pdf_soc ? `${baseUrl}/${targetSchedule.pdf_soc}` : null },
  ].filter(subject => subject.url !== null);

  return (
    <div className="container mt-4">
      {/* 任意: 何回の解答かわかりやすいように見出しをつける */}
      {/* <h4 className="text-center mb-3">第{targetSchedule.kai}回 統一模試 結果</h4> */}

      <div className="row row-cols-1 row-cols-md-2 g-4 mb-5">
        
        {/* 解答・解説カード */}
        {isAnswerVisible && (
          <div className="col">
            <div className="card shadow-lg border-0 border-top border-5 border-primary rounded-4 h-100">
              <div className="card-body d-flex flex-column align-items-center p-4 p-md-5 text-center">
                <h3 style={{ color: 'royalblue' }} className="card-title h4 fw-bold mb-1">解答・解説</h3>
                <div className="d-flex flex-wrap justify-content-center gap-2 my-4">
                  {subjectPdfLinks.map((subject) => (
                    <a
                      key={subject.label}
                      href={subject.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn text-white py-2 px-4 rounded-3 fw-bold"
                      style={{ background: 'royalblue' }}
                    >
                      {subject.label}
                    </a>
                  ))}
                </div>
                {/* 注意書きアラート（省略せずにそのまま記載してください） */}
                <div className="alert alert-warning d-flex align-items-start p-3 w-100 text-start">
                  <div><p className="mb-0 small"><strong className="fw-bold">統一模試の解答解説は、受験回の予約受付期間までの期間限定公開となります。保存したい方は、ダウンロードまたはスクリーンショット等で保存してください。</strong></p></div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 偏差値判定基準カード */}
        {isRankVisible && (
          <div className="col">
            <div className="card shadow-lg border-0 border-top border-5 border-success rounded-4 h-100">
              <div className="card-body d-flex flex-column align-items-center p-4 p-md-5 text-center">
                <h3 style={{ color: '#009d80' }} className="card-title h4 fw-bold mb-1">偏差値判定基準</h3>
                <a href={`https://toitumosi.jp/pdf/${targetSchedule.pdf_rank}`} target="_blank" rel="noopener noreferrer">
                  <button style={{ background: '#009d80' }} className="mt-3 btn w-100 text-white py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2 mb-4 fs-5">
                    偏差値判定基準(PDF)
                  </button>
                </a>
                {/* 以降、階層分布表やWEB判定登録などのボタン・表示は既存のまま */}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}